module.exports = __webpack_public_path__ + "assets/img/tag_list-86f2d96c.png";